// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EditFilledSvg from "@ant-design/icons-svg/es/asn/EditFilled";
import AntdIcon from '../components/AntdIcon';

var EditFilled = function EditFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EditFilledSvg
  }));
};

EditFilled.displayName = 'EditFilled';
export default React.forwardRef(EditFilled);